import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _, { isEmpty, isEqual } from 'lodash';
import * as actions from '../actions';
import * as c from '../constants';
import BillersList from '../component/BillersList';
// import logo from '../../../assets/img/logo.png';
import icn_grid_view from '../../../assets/img/icons/grid-view.svg';
import icn_list_view from '../../../assets/img/icons/list-view.svg';
import icn_category from '../../../assets/img/icons/category.svg';
import icn_a_to_z from '../../../assets/img/icons/a-to-z.svg';
import icn_search from '../../../assets/img/icons/search.svg';

import airlines from '../../../assets/img/category-icons/airlines.svg';
import cable from '../../../assets/img/category-icons/cable.svg';
import electricity from '../../../assets/img/category-icons/electricity.svg';
import government from '../../../assets/img/category-icons/government.svg';
import insurance from '../../../assets/img/category-icons/insurance.svg';
import mobileload from '../../../assets/img/category-icons/mobileload.svg';
import onlineshopping from '../../../assets/img/category-icons/onlineshopping.svg';
import others from '../../../assets/img/category-icons/others.svg';
import realstate from '../../../assets/img/category-icons/realstate.svg';
import ssscontribution from '../../../assets/img/category-icons/sss-contribution.svg';
import telecom from '../../../assets/img/category-icons/telecom.svg';
import utilities from '../../../assets/img/category-icons/utilities.svg';
import water from '../../../assets/img/category-icons/water.svg';

const ICON_BY_CATEGORY = {
  AIRLINES: airlines, // 'fa fa-plane-departure',
  CABLE: cable, // 'fa fa-desktop',
  ELECTRICITY: electricity, // 'fa fa-bolt',
  GOVERNMENT: government, // 'fa fa-university',
  INSURANCE: insurance, // 'fa fa-heart',
  'MOBILE LOAD': mobileload, // 'fa fa-mobile-alt',
  'ONLINE SHOPPING': onlineshopping, // 'fa fa-shopping-cart',
  OTHERS: others, // 'fa fa-ellipsis-h',
  'REAL ESTATE': realstate, // 'fa fa-home',
  'SSS CONTRIBUTION': ssscontribution, // 'fa fa-handshake',
  TELECOM: telecom, // 'fa fa-broadcast-tower',
  INTERNET: telecom, // 'fa fa-broadcast-tower',
  UTILITIES: utilities, // 'fa fa-user-shield',
  WATER: water, // 'fa fa-tint',
};

const getPersist = (key, default_value) => {
  try {
    return sessionStorage.getItem(key) || default_value;
  } catch (err) {
    return default_value;
  }
};

const setPersist = (key, value) => {
  sessionStorage.setItem(key, value);
};

class Categorized extends Component {
  static propTypes = {
    inquiry_no: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.instanceOf(Object).isRequired,
    history: PropTypes.instanceOf(Object).isRequired,
    partner: PropTypes.instanceOf(Object).isRequired,
  }

  state = {
    category: getPersist('category', ''),
    group_by: getPersist('group_by', 'category'),
    keyword: getPersist('keyword', ''),
    view_by: getPersist('view_by', 'list'),
    view_control: getPersist('view_control', true),


    categories: [],
    // billersByCategory: {},
    isSearching: false,

    filteredBillers: [],
  }

  componentDidMount() {
    if (document.documentElement.clientWidth < 768) {
      this.setState({
        view_by: 'list',
        view_control: false,
      });
    }

    const { data } = this.props;
    if (_.isEmpty(data)) {
      const { history, inquiry_no } = this.props;
      history.push(`/${inquiry_no}`);
    }
    const billers = _.get(data, 'formable.billers') || [];
    // const billersByCategory = {};
    const categories = ([...new Set(billers.map(x => x.category))]).sort();
    const hasOthers = categories.indexOf('OTHERS') > -1;
    if (hasOthers) {
      categories.splice(categories.indexOf('OTHERS'), 1);
      categories.push('OTHERS');
    }

    // const categories = ([...new Set(billers.map((x) => {
    //   // billersByCategory[x.category] = (billersByCategory[x.category] || []).concat(x);
    //   return x.category;
    // }))]).sort();
    this.setState({
      categories,
      // billersByCategory,
      isSearching: true,
    });
    this.updateFilteredList(null, null, data);
  }

  componentDidUpdate = (props, state) => {
    const { data } = this.props;
    const { data: oldData } = props;
    const {
      keyword,
      category,
      group_by,
      view_by,
      view_control,
    } = this.state;
    const {
      keyword: oldKeyword,
      category: oldCategory,
      group_by: oldGroupBy,
      view_by: oldViewBy,
      view_control: oldViewControl,
    } = state;
    if (!isEqual(data, oldData)
      || !isEqual(keyword, oldKeyword)
      || !isEqual(category, oldCategory)) {
      this.setState({ filteredBillers: [], isSearching: true });
      this.updateFilteredList(keyword, category, data);
    }
    if (!isEqual(oldCategory, category)) setPersist('category', category);
    if (!isEqual(oldGroupBy, group_by)) setPersist('group_by', group_by);
    if (!isEqual(oldKeyword, keyword)) setPersist('keyword', keyword);
    if (!isEqual(oldViewBy, view_by)) setPersist('view_by', view_by);
    if (!isEqual(oldViewControl, view_control)) setPersist('view_control', view_control);
  }

  // eslint-disable-next-line
  updateFilteredList = _.debounce((keyword, category, data) => {
    setTimeout(() => {
      const filteredBillers = (_.get(data, 'formable.billers') || []).filter(this.searchFilter);
      this.setState({
        filteredBillers,
        isSearching: false,
      });
    }, 0);
  }, 1000);

  handleChangeInput = key => ({ target }) => {
    this.setState({ [key]: target.value });
  }

  searchFilter = ({ name, category }) => {
    const { keyword, category: cat } = this.state;
    return (name || '').toLowerCase().indexOf(keyword.toLowerCase()) > -1 && (_.isEmpty(cat) || category === cat);
  }

  handleSetGroupBy = group_by => () => {
    this.setState({ group_by, category: '' });
  }

  handleSetView = view_by => () => {
    this.setState({ view_by });
  }

  handleSelectCategory = category => (e) => {
    e.preventDefault();
    this.setState({
      category,
    });
  }

  handleResetCategory = (e) => {
    e.preventDefault();
    this.setState({
      category: '',
    });
  }

  render() {
    const { isLoading } = this.props;

    const {
      keyword,
      view_by, group_by,
      categories, category,
      view_control,
      filteredBillers,
      isSearching,
    } = this.state;

    // const filteredBillers = (_.get(data, 'formable.billers') || []).filter(this.searchFilter);
    const { partner } = this.props;

    // let categoryWithBillersCount = 0;

    return (
      <div className="container outer-wrapper">
        <div className="row mb-1">
          <div className="col mx-auto inner-wrapper">
            {/* <div className="text-center">
              <img src={logo} className="img-fluid logo mb-2" alt="" />
              <h6>MultiPay Payment Facility</h6>
            </div> */}
            <div className="main-container bg-header" style={{ borderColor: partner.header_color || '#343a40' }}>
              <div className="mb-2 bg-header mb-2">
                <div className="search-wrapper d-flex align-items-center mx-auto rounded">
                  <span className="append d-flex align-items-center">
                    <img src={icn_search} className="img-icon mr-2" alt="" />
                  </span>
                  <input placeholder="Search Biller..." className="flex-fill" onChange={this.handleChangeInput('keyword')} value={keyword} />
                  {/* <span className="prepend">Press <b>enter</b> to search</span> */}
                  <span className="prepend">
                    <div className="d-flex align-items-center">
                      <div>
                        { group_by === 'a-z' && (
                        <button className={`btn btn-circle ${group_by === 'category' ? 'btn-secondary' : 'btn-outline-secondary'} btn-sm`} type="button" onClick={this.handleSetGroupBy('category')}>
                          <img src={icn_category} className="img-icon" alt="" />
                        </button>
                        )}
                        { group_by === 'category' && (
                        <button className={`btn btn-circle ${group_by === 'a-z' ? 'btn-secondary' : 'btn-outline-secondary'} btn-sm`} type="button" onClick={this.handleSetGroupBy('a-z')}>
                          <img src={icn_a_to_z} className="img-icon" alt="" />
                        </button>
                        )}
                      </div>
                      { !(group_by === 'category' && _.isEmpty(category) && _.isEmpty(keyword)) && view_control && (
                        <div className="ml-2 border-left">
                          <div className="pl-2">
                            { view_by === 'list' && (
                            <button
                              className={`btn btn-circle ${view_by === 'grid' ? 'btn-secondary' : 'btn-outline-secondary'} btn-sm`}
                              type="button"
                              onClick={this.handleSetView('grid')}
                            >
                              <img src={icn_grid_view} className="img-icon" alt="" />
                            </button>
                            )}
                            { view_by === 'grid' && (
                            <button
                              className={`btn btn-circle ${view_by === 'list' ? 'btn-secondary' : 'btn-outline-secondary'} btn-sm`}
                              type="button"
                              onClick={this.handleSetView('list')}
                            >
                              <img src={icn_list_view} className="img-icon" alt="" />
                            </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </span>
                </div>
              </div>
              <div style={{ minHeight: 330 }}>
                { (group_by === 'category' && _.isEmpty(category) && _.isEmpty(keyword)) ? (
                  <div>
                    <div className="text-center">
                      <div className="w-100 pb-3 pt-2 d-flex justify-content-center align-items-center" style={{ minHeight: 29 }}>
                        <h6 className="mb-0">Select Category</h6>
                      </div>
                      <div className="row mb-4 mx-0 no-gutters px-3 pb-3">
                        {categories.map(item => (
                          <div className="col-6 col-md-4" key={item}>
                            <div className="m-2">
                              <a className="d-flex flex-column align-items-center box-biller w-100" href="/" onClick={this.handleSelectCategory(item)}>
                                <div className="mb-2 text-muted category-icon">
                                  <img src={ICON_BY_CATEGORY[item]} alt={item} />
                                </div>
                                <div>{item}</div>
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={`d-flex align-content-stretch flex-wrap px-3 ${view_by}-view`}>
                    { (isLoading || isSearching) && <div className="generic-list-loader shadow-lg" /> }
                    {group_by === 'category' && !isEmpty(category) && (
                      <div className="w-100 pb-3 pt-2 d-flex align-items-center">
                        <a className="btn btn-light btn-sm mr-2" href="/" onClick={this.handleResetCategory}>
                          <i className="fa fa-chevron-left mr-1" />
                          <span className="text">
                            Back
                          </span>
                        </a>
                        <span><h6 className="mb-0"><i className={`${ICON_BY_CATEGORY[category]} mr-1`} />{category}</h6></span>
                      </div>
                    )}
                    <BillersList data={filteredBillers} emptyMessage={!_.isEmpty(keyword) && (isSearching ? 'Searching...' : 'No record found.')} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            <p className="mb-0 text-muted"><small>MultiPay Payment Facility v.1.0</small></p>
            <small className="text-muted">www.multipay.ph</small>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ api }, { match }) => ({
  inquiry_no: match.params.inquiry_no,
  isLoading: api.loading.indexOf(c.INQUIRE) > -1 || api.loading.length > 0,
  partner: _.get(api, `${c.INQUIRE}.item.partner`) || {},
  data: _.get(api, `${c.INQUIRE}.item`) || {},
});

export default connect(mapStateToProps, actions)(Categorized);
